import {texture} from "../core/AssetHelpers";
import {Particles} from "../core/Particles";

export class SparkleBurst extends Particles {

    constructor() {
        super(texture("particle-sparkle")!, {
            alpha: {
                start: 1,
                end: 1,
            },
            scale: {
                start: 0.5,
                end: 0.1,
                minimumScaleMultiplier: 0.5,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 200,
                end: 0,
                minimumSpeedMultiplier: 0.7,
            },
            acceleration: {
                x: 0,
                y: 399,
            },
            maxSpeed: 0,
            startRotation: {
                min: -180,
                max: 0,
            },
            noRotation: false,
            rotationSpeed: {
                min: 0,
                max: 0,
            },
            lifetime: {
                min: 0.2,
                max: 1,
            },
            blendMode: "normal",
            frequency: 0.005,
            emitterLifetime: 0.15,
            maxParticles: 100,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point",
        });
        this.scale.set(3);
    }
}

export class SparkleBurstLarge extends Particles {

    constructor() {
        super(texture("particle-sparkle")!, {
            alpha: {
                start: 1,
                end: 1,
            },
            scale: {
                start: 0.5,
                end: 0.1,
                minimumScaleMultiplier: 0.5,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 200,
                end: 0,
                minimumSpeedMultiplier: 0.7,
            },
            acceleration: {
                x: 0,
                y: 399,
            },
            maxSpeed: 0,
            startRotation: {
                min: 0,
                max: 360,
            },
            noRotation: false,
            rotationSpeed: {
                min: 0,
                max: 0,
            },
            lifetime: {
                min: 0.2,
                max: 1,
            },
            blendMode: "normal",
            frequency: 0.005,
            emitterLifetime: 0.5,
            maxParticles: 100,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point",
        });
        this.scale.set(3);
    }
}
